// Where an impersonation link opens, relative to the page the administrator generated it on.
//
// The auth service builds the link on the Cloud base (app.ambifi.com) even when the administrator asks for it from an
// SSO host such as hca.ambifi.com, whose /login routes go to the identity provider. Sessions live per origin, so a link
// for another origin opens in a new tab while this session stays signed in; a link for this origin replaces this session.

const MAGIC_LINK_PATH = "/login/authenticate-magic-link/";

export function isImpersonationLink(link) {
	if (typeof link !== "string" || link === "") {
		return false;
	}
	try {
		const url = new URL(link);
		return url.protocol === "https:" && url.pathname.startsWith(MAGIC_LINK_PATH) && url.pathname.length > MAGIC_LINK_PATH.length;
	} catch (e) {
		return false;
	}
}

export function getLinkOrigin(link, currentOrigin) {
	try {
		return new URL(link, currentOrigin).origin;
	} catch (e) {
		return "";
	}
}

export function opensOnAnotherOrigin(link, currentOrigin = window.location.origin) {
	const linkOrigin = getLinkOrigin(link, currentOrigin);
	return linkOrigin !== "" && linkOrigin !== currentOrigin;
}

export function impersonationLinkNote(link, currentOrigin = window.location.origin) {
	if (opensOnAnotherOrigin(link, currentOrigin)) {
		const host = new URL(link, currentOrigin).host;
		return `This link opens on ${host} in a new tab; this session stays signed in here. Any ${host} session already open in this browser is replaced, so copy the link into a private window to keep that one.`;
	}
	return "Opening this link here ends this session and signs you in as that user. To keep this session, copy the link and open it in a private window.";
}
